"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const tags = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-tags` : '') + (description ? ` desc-tags` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-tags"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-tags"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#232323",
    clipPath: "url(#clip0_28089_2377)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.22 9.654a1.125 1.125 0 1 1 .581 2.174 1.125 1.125 0 0 1-.581-2.174"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.393 4.813a2.25 2.25 0 0 1 1.49.274v-.002l11.94 6.894a2.253 2.253 0 0 1 .824 3.073l-4.332 7.507a2.25 2.25 0 0 1-3.076.823L3.3 16.49a2.26 2.26 0 0 1-.981-1.157l-.067-.21-1.586-5.92a2.25 2.25 0 0 1 1.59-2.755L8.178 4.86zm-5.75 3.083a.75.75 0 0 0-.53.918l1.586 5.92a.75.75 0 0 0 .349.455l11.942 6.894a.76.76 0 0 0 .57.076.75.75 0 0 0 .455-.35l4.332-7.507a.75.75 0 0 0-.273-1.023L9.132 6.385a.75.75 0 0 0-.423-.1l-.146.025z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.45.827a2.25 2.25 0 0 1 1.707.224L23.48 8.165a.75.75 0 0 1-.75 1.3L10.407 2.35a.75.75 0 0 0-.423-.1l-.145.025-6.645 1.78a.75.75 0 0 1-.388-1.449z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_28089_2377"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
var _default = exports.default = tags;